import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";
import notFoundManImg from "../assests/not_found_man.png";

export default function NotFoundPage() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100 bg-white">
      <HeaderComponent user={null} />
      {/* <NavigationPanelComponent /> */}

      <section className="flex-grow-1 d-flex align-items-center justify-content-center text-center p-4">
        <div className="container" data-aos="fade-up">
          <img
            src={notFoundManImg}
            alt="Page not found"
            className="img-fluid mb-4"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
          <h2 className="fw-bold text-black mb-3">
            Hmm... We can't find that page!
          </h2>
          <p className="lead mb-4 text-secondary">
            Looks like the page you’re looking for is under development or
            doesn’t exist.
          </p>
          <Link to="/" className="btn btn-dark px-4 py-2">
            Back to Home
          </Link>
        </div>
      </section>

      <FooterComponent />
    </div>
  );
}
